import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Category pages open the product listing filtered to that category, so
 * shoppers get one catalogue experience (the same filters, sorting and
 * cards) wherever they come from. Old /category/<slug> links keep working.
 * The theme editor still previews the collection template itself.
 */
const CategoryRedirect = ({ landing }) => {
  const { slug } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  if (params.get('themePreview') === '1') return landing;
  params.set('category', slug);
  return <Navigate to={`/products?${params.toString()}`} replace />;
};

export default CategoryRedirect;
